import {
  TableCellType,
  TableHeader,
} from "../../../../../../components/custom-table/table";
import { CmmInputUniqueValuesTableColumnKeys } from "../../../../../../enums/tableColumnKeys";

// export const ConditionListTableHeader: TableHeader[] = [
//   {
//     label: "JSON Param Name",
//     key: ConditionListTableColumnKeys.JSON_PARAM_NAME,
//     order: 1,
//     width: 20,
//     sortable: true,
//     type: TableCellType.STRING,
//   },
//   {
//     label: "Field Name",
//     key: ConditionListTableColumnKeys.FIELD_NAME,
//     order: 2,
//     width: 20,
//     sortable: true,
//     type: TableCellType.EDITABLE_TEXT,
//   },
//   {
//     label: "Show on Condition List",
//     key: ConditionListTableColumnKeys.SHOW_ON_CONDITION_LIST,
//     order: 3,
//     width: 15,
//     sortable: false,
//     type: TableCellType.TOGGLE_SWITCH,
//   },
//   {
//     label: "Data Type",
//     key: ConditionListTableColumnKeys.DATA_TYPE,
//     order: 4,
//     width: 10,
//     sortable: true,
//     type: TableCellType.STRING,
//   },
//   {
//     label: "Options",
//     key: ConditionListTableColumnKeys.OPTIONS,
//     order: 5,
//     width: 35,
//     sortable: true,
//     type: TableCellType.STRING,
//   },
// ];

export const CmmInputUniqueValuesTableHeader: TableHeader[] = [
  {
    label: "Column Name",
    key: CmmInputUniqueValuesTableColumnKeys.COLUMN_NAME,
    order: 1,
    width: 15,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Field Name",
    key: CmmInputUniqueValuesTableColumnKeys.FIELD_NAME,
    order: 2,
    width: 15,
    sortable: true,
    type: TableCellType.EDITABLE_TEXT,
  },
  {
    label: "Show on List",
    key: CmmInputUniqueValuesTableColumnKeys.SHOW_ON_LIST,
    order: 3,
    width: 10,
    sortable: false,
    type: TableCellType.TOGGLE_SWITCH,
  },
  {
    label: "Data Type",
    key: CmmInputUniqueValuesTableColumnKeys.DATA_TYPE,
    order: 4,
    width: 10,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "Top Values",
    key: CmmInputUniqueValuesTableColumnKeys.TOP_VALUES,
    order: 5,
    width: 50,
    sortable: false,
    type: TableCellType.BADGE_GROUP_WITH_EDIT_ICON,
  },
];
